import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles/variables';
import { FavoriteWithCount, TwitterWithText } from '@lean-body/components/molecules';
export const PlaylistInfo = ({ playlist, totalFavoriteCount, creator, isFavorited, numOfLessons, programTotalMinCal, programTotalMaxCal, updatedDiff, onClickFavorite, className, isOriginalPlaylist, twitterService, onClickTwitterShareIfAuthed, }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const toggleText = () => setIsOpen(!isOpen);
    const wrapperClass = [className || '', css(styles.wrapper)].join(' ');
    const playlistName = playlist.name;
    const playlistDescription = playlist.description;
    const totalDuration = playlist.totalDuration;
    let descriptionClass;
    if (isOpen) {
        descriptionClass = css(styles.description);
    }
    else {
        descriptionClass = [css(styles.description), css(styles.omitDescription)].join(' ');
    }
    return (React.createElement("div", { className: wrapperClass },
        React.createElement("div", { className: css(styles.playlistTitle) }, playlistName),
        React.createElement("div", { className: css(styles.playlistCreator) },
            React.createElement("span", { className: css(styles.creatorImgContainer) },
                React.createElement("img", { src: creator.iconSrc, height: 22 })),
            React.createElement("span", { className: css(styles.creatorName) }, creator.name)),
        React.createElement("div", { className: css(styles.calInfo) },
            programTotalMinCal,
            " - ",
            programTotalMaxCal,
            " kcal"),
        React.createElement("div", { className: css(styles.labelInfo) },
            numOfLessons,
            "\u30EC\u30C3\u30B9\u30F3",
            totalDuration && `・${totalDuration}`,
            updatedDiff && `・${updatedDiff}更新`),
        !isOriginalPlaylist && (React.createElement("div", { className: css(styles.userActionRow) },
            React.createElement(FavoriteWithCount, { favCount: totalFavoriteCount, onClick: onClickFavorite, isStoppedFav: !isFavorited }),
            React.createElement(TwitterWithText, { text: "\u30B7\u30A7\u30A2\u3059\u308B", twitterService: twitterService, onClickTwitterShareIfAuthed: onClickTwitterShareIfAuthed, playlist: playlist }))),
        playlistDescription !== '' && (React.createElement("div", { onClick: toggleText },
            React.createElement("div", { className: descriptionClass },
                React.createElement("span", null, playlistDescription)),
            React.createElement("div", { className: css(styles.toggleText) }, isOpen ? '閉じる' : 'すべて見る')))));
};
const styles = StyleSheet.create({
    wrapper: {
        padding: '0 32px',
        [MediaBreakPointUp.MD]: {
            padding: '0 100px',
        },
    },
    playlistTitle: {
        fontWeight: 'bold',
        fontSize: 18,
    },
    playlistCreator: {
        display: 'flex',
        alignItems: 'center',
        margin: '12px 0',
    },
    creatorImgContainer: {
        width: 22,
        height: 22,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: Colors.White,
        borderRadius: '15px',
        border: `1px solid ${Colors.BorderLightGrayB}`,
        overflow: 'hidden',
    },
    outlinedHeart: {
        width: 17,
    },
    creatorName: {
        marginLeft: 8,
        fontSize: 11,
        fontWeight: 'bold',
    },
    userActionRow: {
        display: 'flex',
        gap: 15,
    },
    description: {
        position: 'relative',
        marginTop: 8,
        fontSize: 12,
        letterSpacing: '1px',
        lineHeight: 1.7,
    },
    omitDescription: {
        display: '-webkit-box',
        '-webkit-box-orient': 'vertical',
        '-webkit-line-clamp': '3',
        overflow: 'hidden',
        ':before': {
            content: "' '",
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0) 52%, rgb(242, 246, 247))',
        },
    },
    toggleText: {
        marginTop: 12,
        color: Colors.GrayDarkest,
        fontSize: 11,
        textAlign: 'center',
        textDecoration: 'underline',
    },
    calInfo: {
        fontSize: 12,
        fontWeight: 'bold',
        margin: '8px 0 6px',
    },
    labelInfo: {
        fontSize: 11,
        marginBottom: 8,
        color: Colors.GrayDarkest,
    },
});
